import {
  useFindAllHardwareQuery,
  useFindAllModulesQuery,
  useFindAllSoftwareQuery,
} from '../../api/api-hooks';
import FilterBar from '../../components/FilterBar';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { LicenseFilter } from './licensesTypes';

interface Props {
  filters: LicenseFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: LicenseFilter;
}

const LicensesFilterBar = ({ filters, setFilters, initialFilters }: Props) => {
  const { data: allSoftware } = useFindAllSoftwareQuery({});
  const { data: allHardware } = useFindAllHardwareQuery({});
  const { data: allModules } = useFindAllModulesQuery({});
  if (
    allSoftware === undefined ||
    allHardware === undefined ||
    allModules === undefined
  )
    return null;
  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={() => true}
        children={(
          handler: (event: any, value?: any, label?: string) => void
        ) => [
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'software');
            }}
            value={filters.software}
            options={allSoftware}
            getOptionLabel={(softwareType) => softwareType.type}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Filter By Software'
                variant='outlined'
              />
            )}
          />,
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'hardware');
            }}
            value={filters.hardware}
            options={allHardware}
            getOptionLabel={(hardware) => hardware.serial}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Filter By Hardware'
                variant='outlined'
              />
            )}
          />,
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'module');
            }}
            value={filters.module}
            options={allModules}
            getOptionLabel={(module) => module.moduleName}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Filter By Module'
                variant='outlined'
              />
            )}
          />,
        ]}
      />
    </>
  );
};

export default LicensesFilterBar;
